export const BASE_PLAN_CURRENCY = 'INR';
export const PLAN_CURRENCY_OPTIONS = ['INR', 'USD'];
export const INR_PER_USD = 83.5;

const roundCurrencyAmount = (amount) => Math.round((amount + Number.EPSILON) * 100) / 100;

const coerceNumericValue = (value) => {
  if (value === '' || value === null || value === undefined) {
    return null;
  }
  const amount = Number.parseFloat(value);
  return Number.isFinite(amount) ? amount : null;
};

export const convertPlanPriceFromBase = (value, currency = BASE_PLAN_CURRENCY) => {
  const amount = coerceNumericValue(value);
  if (amount === null) {
    return '';
  }
  if (currency === 'USD') {
    return String(roundCurrencyAmount(amount / INR_PER_USD));
  }
  return String(roundCurrencyAmount(amount));
};

export const convertPlanPriceToBase = (value, currency = BASE_PLAN_CURRENCY) => {
  const amount = coerceNumericValue(value);
  if (amount === null) {
    return '';
  }
  if (currency === 'USD') {
    return String(roundCurrencyAmount(amount * INR_PER_USD));
  }
  return String(roundCurrencyAmount(amount));
};

export const formatPlanPriceFromBase = (value, currency = BASE_PLAN_CURRENCY) => {
  const amount = coerceNumericValue(value) ?? 0;
  const displayAmount = currency === 'USD' ? amount / INR_PER_USD : amount;
  return new Intl.NumberFormat(currency === 'INR' ? 'en-IN' : 'en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: 2,
  }).format(roundCurrencyAmount(displayAmount));
};

export const formatCurrencyAmount = (value, currency = BASE_PLAN_CURRENCY) => {
  const amount = coerceNumericValue(value) ?? 0;
  const normalizedCurrency = String(currency || BASE_PLAN_CURRENCY).toUpperCase();
  return new Intl.NumberFormat(normalizedCurrency === 'INR' ? 'en-IN' : 'en-US', {
    style: 'currency',
    currency: normalizedCurrency,
    maximumFractionDigits: 2,
  }).format(roundCurrencyAmount(amount));
};
